export default function PHP_multi_query() {
  return (
    <div>
      <h1>PHP_multi_query</h1>
    </div>
  );
}
